import { IColor } from './theme/color';

const Vendor: IVendor = {
	gui: {
		theme: 'dark',
		asset: {
			logo: '/icons/game_explorer_logo.svg',
			logoSmall: '/icons/hash_logo.svg',
		},
		color: {
			action: ['#ea732b', '#FF3F3F'],
			actionSecondary: ['#ea732b', '#FF3F3F'],
			background: ['#FFFFFF', '#0A0A08'],
			backgroundLight: ['#eeeeee', '#1D1D1D'],
			backgroundSecondary: ['#F9F9F9', '#252525'],
			backgroundTertiary: ['#F0F2F5', '#797B7E'],
			backgroundAccent: ['#F0F2F5', '#10100E'],
			text: ['#000000', '#FFFFFF'],
			textSecondary: ['#FFFFFF', '#000000'],
			textAction: ['#FFFFFF', '#FFFFFF'],
		},
	},
	data: {
		externalUri: {
			linkedin: 'https://www.linkedin.com/company/hashupit/',
			telegram: 'https://t.me/HashUpAnnouncements',
			facebook: 'https://www.facebook.com/HashUpIt',
			instagram: 'https://www.instagram.com/hashup.it/',
			twitter: 'https://twitter.com/HashUp_it',
			web: 'https://HashUp.it',
			newsletter: 'https://hashup.it/#newsletter',
		},
		company: {
			name: 'HashUp P.S.A.',
			addressLine: { first: 'al. Jana Pawła II 27', second: '00-867 Warsaw' },
			mail: 'hello@hashup.it',
			identifiers: ['NIP: 5272974670', 'KRS: 0000927509'],
		},
		branding: {
			cartridge: 'The HashUp',
		},
	},
};

interface IVendor {
	gui: {
		theme: 'light' | 'dark';
		asset: { [p in 'logo' | 'logoSmall']: string };
		color: { [p in IColor]: string[] | string } | any;
	};
	data: {
		externalUri: {
			[p in 'linkedin' | 'telegram' | 'facebook' | 'instagram' | 'twitter' | 'web' | 'newsletter']: string;
		};
		company: {
			name: string;
			addressLine: {
				first: string;
				second: string;
			};
			mail: string;
			identifiers: string[];
		};
		branding: {
			cartridge: string;
		};
	};
}

export default Vendor;
